const generateActions = function(actions) {
  const actionMap = {};
  for (const i in actions) {
    const action = actions[i];
    actionMap[action] = action;
    actionMap[`${action}_BEGIN`] = `${action}_BEGIN`;
    actionMap[`${action}_DONE`] = `${action}_DONE`;
    actionMap[`${action}_FAIL`] = `${action}_FAIL`;
  }
  return actionMap;
};

export default generateActions([
  'LOGIN',
  'LOGOUT',
  'SEND_OTP',
  'VERIFY_OTP',
  'RESEND_OTP',
  'ORDER_DETAIL_IMAGES',
  'REMOVE_DETAIL_IMAGES',
  'GET_WAREHOUSES',
  'SET_WAREHOUSE',
  'GET_ORDER_DETAILS',
  'ADD_REMARKS',
  'UPLOAD_IMAGES',
  'ADD_WAVE',
  'GET_ORDERS',
  'REUPLOAD_WAVE',
  'ORDER_STATUS_ACTION',
  'RESET_GET_ORDERS',
  'RESET_ORDER_DETAIL_IMAGES',
  'REMOVE_DETAIL_IMAGES_ORDER',
  'GET_ORDER_PHONES',
  'SEND_DELIVERY_OTP',
  'VERIFY_DELIVERY_OTP',
  'RESEND_DELIVERY_OTP',
  'GET_ALL_ISSUE_REASONS',
  'GET_ORDER_PRODUCTS',
  'SAVE_PRODUCT_ISSUES',
  'UPDATE_ORDER',
  'DELETE_PRODUCT_ISSUES',
  'GET_DELIEVRY_ISSUE_REASONS',
  'ORDER_RESAON_DETAIL_IMAGES',
  'CANCEL_DELIVERY_ISSUE',
  'INVOICE_IMAGES',
  'IMAGE_COMPRESSION',
  'STORE_IMAGES',
  'SET_ORDER_ASSET',
  'UPDATE_DA_COLLECTED_AMOUNT'
]);


export const REMOVE_IMAGE = 'REMOVE_IMAGE';
export const RESET_COMPRESSED_IMAGES = 'RESET_COMPRESSED_IMAGES';
export const RESET_STORE_IMAGES = 'RESET_STORE_IMAGES';
export const FETCH_APP_CONFIG = 'FETCH_APP_CONFIG';
export const GET_ORDER_ASSETS = 'GET_ORDER_ASSETS';
export const GET_ASSETS_TYPES = 'GET_ASSETS_TYPES';
export const SET_ORDER_ASSET = 'SET_ORDER_ASSET';
export const DELETE_ASSET_ERROR = 'DELETE_ASSET_ERROR'; 
